(function () {
  'use strict';

  if (window.__kwB2bBoostGridCustom) return;

  var MOBILE_LAYOUT_MQL = window.matchMedia('(max-width: 989px)');
  var DESKTOP_LAYOUT_MQL = window.matchMedia('(min-width: 990px)');
  var SMALL_DESKTOP_MQL = window.matchMedia('(min-width: 1024px)');
  var MEDIUM_DESKTOP_MQL = window.matchMedia('(min-width: 1440px)');
  var LARGE_DESKTOP_MQL = window.matchMedia('(min-width: 1600px)');

  function clampCols(value, min, max) {
    var cols = parseInt(value, 10);
    if (!cols || cols < min) cols = min;
    if (cols > max) cols = max;
    return cols;
  }

  function readCols(attr, fallback, min, max) {
    var raw =
      document.documentElement.getAttribute(attr) ||
      (fallback != null ? String(fallback) : '');
    return clampCols(raw, min, max);
  }

  function getDesktopCols() {
    return readCols('data-b2b-products-per-row', window.__b2bProductsPerRow, 3, 10);
  }

  function getTabletCols() {
    return readCols('data-b2b-products-per-row-tablet', window.__b2bProductsPerRowTablet, 2, 6);
  }

  function getMobileCols() {
    return readCols('data-b2b-products-per-row-mobile', window.__b2bProductsPerRowMobile, 1, 4);
  }

  function getProductsPerRow() {
    if (LARGE_DESKTOP_MQL.matches) return getDesktopCols();
    if (MEDIUM_DESKTOP_MQL.matches) return 4;
    if (SMALL_DESKTOP_MQL.matches) return 3;
    if (DESKTOP_LAYOUT_MQL.matches) return getTabletCols();
    return getMobileCols();
  }

  function isB2B() {
    return (
      document.documentElement.getAttribute('data-b2b-wholesale') === 'true' ||
      window.__b2bWholesaleActive === true ||
      document.documentElement.classList.contains('b2b-wholesale-mode')
    );
  }

  function isListView(list) {
    return (
      list.classList.contains('boost-sd__product-list--list') ||
      list.classList.contains('boost-sd__product-list-view-list') ||
      list.getAttribute('data-view') === 'list'
    );
  }

  function syncGridClass(list, cols) {
    var targetClass = 'boost-sd__product-list-grid--' + cols + '-col';
    Array.from(list.classList).forEach(function (cls) {
      if (/^boost-sd__product-list-grid--\d+-col$/.test(cls) && cls !== targetClass) {
        list.classList.remove(cls);
      }
    });
    list.classList.add(targetClass);
  }

  function clearListOverrides(list) {
    [
      'display',
      'grid-template-columns',
      'gap',
      'width',
      'max-width',
    ].forEach(function (prop) {
      list.style.removeProperty(prop);
    });

    list.querySelectorAll('.boost-sd__product-item, .boost-pfs-filter-product-item').forEach(function (item) {
      ['width', 'max-width', 'flex', 'margin'].forEach(function (prop) {
        item.style.removeProperty(prop);
      });
    });
  }

  function applyList(list) {
    if (!isB2B() || isListView(list)) return;

    if (DESKTOP_LAYOUT_MQL.matches && !SMALL_DESKTOP_MQL.matches) {
      clearListOverrides(list);
      return;
    }

    if (!MOBILE_LAYOUT_MQL.matches && !SMALL_DESKTOP_MQL.matches) {
      clearListOverrides(list);
      return;
    }

    var cols = getProductsPerRow();
    syncGridClass(list, cols);

    list.style.setProperty('display', 'grid', 'important');
    list.style.setProperty('grid-template-columns', 'repeat(' + cols + ', minmax(0, 1fr))', 'important');
    list.style.setProperty('gap', '16px', 'important');
    list.style.setProperty('width', '100%', 'important');
    list.style.setProperty('max-width', 'none', 'important');

    list.querySelectorAll('.boost-sd__product-item, .boost-pfs-filter-product-item').forEach(function (item) {
      item.style.setProperty('width', '100%', 'important');
      item.style.setProperty('max-width', 'none', 'important');
      item.style.setProperty('flex', 'none', 'important');
      item.style.setProperty('margin', '0', 'important');
    });
  }

  function getTitleFontSizePx() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--b2b-product-title-font-size').trim();
    if (!raw) raw = '16px';
    return raw;
  }

  function getTitleFontSizeMobilePx() {
    var desktop = parseFloat(getTitleFontSizePx());
    if (!desktop || desktop < 12) desktop = 16;
    return Math.round(desktop * 0.875) + 'px';
  }

  function applyTitles() {
    if (!isB2B()) return;

    var size = MOBILE_LAYOUT_MQL.matches ? getTitleFontSizeMobilePx() : getTitleFontSizePx();
    document.querySelectorAll('.boost-sd__product-title, .boost-sd__product-title a').forEach(function (el) {
      el.style.setProperty('font-size', size, 'important');
    });
  }

  function clearParentOverrides() {
    var selectors = [
      '[class*="nav-col-"] .page-width',
      '[class*="nav-col-"] .facets-vertical',
      '[class*="nav-col-"] .product-grid-container',
      '.template-search .facets-vertical.page-width',
      '.template-search .facets-wrapper.page-width',
      '.template-search .product-grid-container',
      '.template-search .product-grid-container .collection',
      '.boost-sd-container',
      '.boost-sd-layout',
      '.boost-product-listing-column',
      '.boost-sd-right',
    ];

    document.querySelectorAll('.boost-sd-container').forEach(function (boostRoot) {
      var parent = boostRoot.parentElement;
      while (parent && parent !== document.documentElement) {
        if (
          parent.classList.contains('page-width') ||
          parent.classList.contains('container') ||
          parent.classList.contains('product-grid-container') ||
          parent.classList.contains('facets-vertical')
        ) {
          parent.style.removeProperty('width');
          parent.style.removeProperty('max-width');
        }
        parent = parent.parentElement;
      }
    });

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.removeProperty('width');
        el.style.removeProperty('max-width');
      });
    });
  }

  function applyParents() {
    if (!isB2B()) return;

    if (!SMALL_DESKTOP_MQL.matches) {
      clearParentOverrides();
      return;
    }

    document.querySelectorAll('.boost-sd-container').forEach(function (boostRoot) {
      var parent = boostRoot.parentElement;
      while (parent && parent !== document.documentElement) {
        if (
          parent.classList.contains('page-width') ||
          parent.classList.contains('container') ||
          parent.classList.contains('product-grid-container') ||
          parent.classList.contains('facets-vertical')
        ) {
          parent.style.setProperty('width', '100%', 'important');
          parent.style.setProperty('max-width', 'none', 'important');
        }
        parent = parent.parentElement;
      }
    });

    var selectors = [
      '[class*="nav-col-"] .page-width',
      '[class*="nav-col-"] .facets-vertical',
      '[class*="nav-col-"] .product-grid-container',
      '.template-search .facets-vertical.page-width',
      '.template-search .facets-wrapper.page-width',
      '.template-search .product-grid-container',
      '.template-search .product-grid-container .collection',
      '.boost-sd-container',
      '.boost-sd-layout',
      '.boost-product-listing-column',
      '.boost-sd-right',
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', 'none', 'important');
      });
    });
  }

  function applyAll() {
    if (!isB2B()) return;
    applyParents();
    applyTitles();
    document.querySelectorAll('.boost-sd__product-list, .boost-pfs-filter-products').forEach(applyList);
    if (window.__kwB2bBoostQuickAdd && typeof window.__kwB2bBoostQuickAdd.apply === 'function') {
      window.__kwB2bBoostQuickAdd.apply();
    }
  }

  window.__kwB2bBoostGridCustom = {
    apply: applyAll,
    isB2B: isB2B,
    getDesktopCols: getDesktopCols,
    getTabletCols: getTabletCols,
    getMobileCols: getMobileCols,
    getProductsPerRow: getProductsPerRow,
  };

  window.__BoostCustomization__ = (window.__BoostCustomization__ || []).concat([
    function (componentRegistry) {
      componentRegistry.useModulePlugin('FilterController', {
        name: 'KWB2B configurable column grid',
        apply: function (builder) {
          builder.on('methodFulfilled', 'handleProductListResponsive', function () {
            applyAll();
          });
        },
      });
    },
  ]);

  [MOBILE_LAYOUT_MQL, DESKTOP_LAYOUT_MQL, SMALL_DESKTOP_MQL, MEDIUM_DESKTOP_MQL, LARGE_DESKTOP_MQL].forEach(function (mql) {
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', applyAll);
    }
  });

  window.addEventListener('resize', applyAll);
  window.addEventListener('load', applyAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  if (window.MutationObserver) {
    new MutationObserver(applyAll).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  setInterval(applyAll, 750);
})();
